<div class="ui basic segment max-width" [class.loading]="isLoading">
    <app-header [back]="true" title="{{ 'time-off-v3.createTimeOffType' }}"></app-header>

    <app-time-off-types-form #timeOffTypesForm [timeOffType]="timeOffType"></app-time-off-types-form>

    <div class="buttons">
        <ui-button type="outline" (click)="onCancel()">{{ 'time-off-v3.cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSave()">{{ 'time-off-v3.save' | translate }}</ui-button>
    </div>
</div>
